const RENDER_TIME_KEY = "__TECHNIA_RENDER_TIME__";

function readRenderTime() {
  if (typeof globalThis === "undefined") return null;
  const value = globalThis[RENDER_TIME_KEY];
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function getRenderDate() {
  return readRenderTime() || new Date();
}

export function clearRenderClock() {
  if (typeof globalThis === "undefined") return;
  try {
    delete globalThis[RENDER_TIME_KEY];
  } catch {
    globalThis[RENDER_TIME_KEY] = undefined;
  }
}
